export enum RecordStatus {
    TRANSCRIBING,
    TRANSCRIPTED,
    FAILED,
    CANCELED,
    DELETED
}